// Calls an Edge Function without putting supabase-js (~180 KB) in the shared bundle: the
// client is imported on first use, so pages that only read a public endpoint after mount
// (GitHub stats, promo status) don't download it up front.
export async function invokeFunction(name: string) {
  const { supabase } = await import('./client');
  return supabase.functions.invoke(name);
}
